import { arrayToMap, arrayToCategorizedMapWithMultipleKeys } from '../util'

export const path = '/master/common';

export const handler = (data) => {
  return {
    list: data.lines,
    bySlug: arrayToMap(data.lines, "slug"),
    byPref: arrayToCategorizedMapWithMultipleKeys(data.lines, "prefs"),
  };
}



// WEBPACK FOOTER //
// ./lib/masterData/schemas/line.js